import { routerMiddleware } from 'connected-react-router';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const createHistory = require('history').createBrowserHistory;
import { applyMiddleware, compose, createStore } from 'redux';
import { createRootReducer, StorageState } from '../reducers';
import thunk from 'redux-thunk';

export const history = createHistory();
const router = routerMiddleware(history);

const middleware = [
    thunk,
    router,
].filter(Boolean);

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

export const configureStore = () => createStore<StorageState, any, any, any>(
    createRootReducer(history),
    (window as any).__PRELOADED_STATE__,
    enhancer,
);

export const store = configureStore();
